import axios from "axios";

export const fetchTokenByValue = async (tokenValue, bearer) => {
  try {
    const response = await axios.get(
      process.env.REACT_APP_BASE_URL_REST_API_TOKEN,
      {
        headers: {
          Authorization: `Bearer ${bearer}`,
        },
        params: {
          token_value: tokenValue,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const fetchTokenByRequest = async (requestId, bearer) => {
  try {
    const response = await axios.get(
      process.env.REACT_APP_BASE_URL_REST_API_TOKEN,
      {
        headers: {
          Authorization: `Bearer ${bearer}`,
        },
        params: {
          request_id: requestId,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error(error);
  }
};
